import { get, set } from "es-toolkit/compat";

import { assert } from "../../asserts/index.ts";
import type { MultilingualNodeConfig } from "../../schemas/index.ts";
import { extractMultilingualProperties, isMultilingualProperty } from "../../shared/index.ts";

interface Options {
  getConfig: (nodeId: number) => MultilingualNodeConfig;
  setConfig: (nodeId: number, config: MultilingualNodeConfig) => void;
  primaryLanguageCode: string;
}

/** For tests. do not use directly */
export const setNodeMultilingualPropertiesCreate =
  ({ getConfig, setConfig, primaryLanguageCode }: Options) =>
  ({ nodeId, properties }: { nodeId: number; properties: string[] }) => {
    const nodeConfig = structuredClone(getConfig(nodeId));
    const existingProperties = extractMultilingualProperties(nodeConfig);
    const existingPropertyNames = existingProperties.map(({ path }) => path);
    const propertyNamesToMulti = properties.filter((property) => !existingPropertyNames.includes(property));
    const propertyNamesToMono = existingPropertyNames.filter((property) => !properties.includes(property));
    for (const name of propertyNamesToMulti) {
      const value = get(nodeConfig, name);
      set(nodeConfig, name, { __ml: { [primaryLanguageCode]: value } });
    }
    for (const name of propertyNamesToMono) {
      const value = get(nodeConfig, name);
      assert(isMultilingualProperty(value), "Expected multilingual property");
      set(nodeConfig, name, value.__ml[primaryLanguageCode]);
    }
    setConfig(nodeId, nodeConfig);
  };

export type SetNodeMultilingualProperties = ReturnType<typeof setNodeMultilingualPropertiesCreate>;
